import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponseBase, HttpResponse } from '@angular/common/http';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { GetRecNameSearchReportQuery, GetRegNameSearchReportQuery, GetRegNameSearchReportResponse, GetRecNameSearchReportResponse, GetRegAddressSearchReportResponse, GetRegAddressSearchReportQuery, GetRecAddressSearchQuery, ISearchReportResponse, SearchReportResponseBase, GetRecAddressSearchReportResponse, GetRecAddressSearchReportQuery, GetRecDateSearchReportQuery, GetRecDateSearchReportResponse, GetRegDateSearchReportQuery, GetRegDateSearchReportResponse, GetRegValueSearchReportQuery, GetRegValueSearchReportResponse, GetRecValueSearchReportQuery, GetRecValueSearchReportResponse, GetPropertySearchReportQuery, GetPropertySearchReportResponse, GetRegOwnerSearchReportQuery, GetRegOwnerSearchReportResponse } from '../viewmodels/ISearchService';


export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}



@Injectable()
export class ReportViewerService {
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  myAppUrl: string = "";
  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  createReport() {
    return this._http.get(this.myAppUrl + 'api/Home/CreateReport');
  }

  getRecNameSearchReport(search: GetRecNameSearchReportQuery): Observable<GetRecNameSearchReportResponse> {
    let url_ = this.myAppUrl + "api/CoreData/GetRecNameSearchReport";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecNameSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecNameSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRecNameSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRecNameSearchReportResponse>><any>_observableThrow(response_);

    }));


  }

  processGetRecNameSearchReportResponse(response: HttpResponseBase): Observable<GetRecNameSearchReportResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetRecNameSearchReportResponse.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<GetRecNameSearchReportResponse>(<any>null);

  }
  blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
      if (!blob) {
        observer.next("");
        observer.complete();
      } else {
        let reader = new FileReader();
        reader.onload = event => {
          observer.next((<any>event.target).result);
          observer.complete();
        };
        reader.readAsText(blob);
      }
    });
  }
  throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
      return _observableThrow(result);
    else
      return _observableThrow(new SwaggerException(message, status, response, headers, null));
  }


  getRegNameSearchReport(search: GetRegNameSearchReportQuery): Observable<GetRegNameSearchReportResponse> {
    let url_ = this.myAppUrl + "api/CoreData/GetRegNameSearchReport";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecNameSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecNameSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRegNameSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRegNameSearchReportResponse>><any>_observableThrow(response_);

    }));

  }

  getRegAddressSearchReport(search: GetRegAddressSearchReportQuery): Observable<GetRegAddressSearchReportResponse> {

    let url_ = this.myAppUrl + "api/CoreData/GetRegAddressSearchReport";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecNameSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecNameSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRegAddressSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRegAddressSearchReportResponse>><any>_observableThrow(response_);

    }));

  }

  getRecAddressSearchReport(search: GetRecAddressSearchReportQuery): Observable<GetRecAddressSearchReportResponse> {
    let url_ = this.myAppUrl + "api/CoreData/GetRecAddressSearchReport";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRecAddressSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRecAddressSearchReportResponse>><any>_observableThrow(response_);

    }));

  }
  getRecDateSearchReport(search: GetRecDateSearchReportQuery): Observable<GetRecDateSearchReportResponse> {
    let url_ = this.myAppUrl + "api/CoreData/GetRecDateSearchReport";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRecDateSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRecDateSearchReportResponse>><any>_observableThrow(response_);

    }));

  }

  getRegDateSearchReport(search: GetRegDateSearchReportQuery): Observable<GetRegDateSearchReportResponse> {
    let url_ = this.myAppUrl + "api/CoreData/GetRegDateSearchReport";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRegDateSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRegDateSearchReportResponse>><any>_observableThrow(response_);

    }));

  }

  getRegValueSearchReport(search: GetRegValueSearchReportQuery): Observable<GetRegValueSearchReportResponse> {
    let url_ = this.myAppUrl + "api/CoreData/GetRegValueSearchReport";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRegValueSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRegValueSearchReportResponse>><any>_observableThrow(response_);

    }));

  }

  getRecValueSearchReport(search: GetRecValueSearchReportQuery): Observable<GetRecValueSearchReportResponse> {
    let url_ = this.myAppUrl + "api/CoreData/GetRecValueSearchReport";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRecValueSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRecValueSearchReportResponse>><any>_observableThrow(response_);

    }));

  }

  getPropertySearchReport(search: GetPropertySearchReportQuery): Observable<GetPropertySearchReportResponse> {
    let url_ = this.myAppUrl + "api/CoreData/GetPropertySearchReportResult";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetPropertySearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetPropertySearchReportResponse>><any>_observableThrow(response_);

    }));

  }

  getRegOwnerSearchReport(search: GetRegOwnerSearchReportQuery): Observable<GetRegOwnerSearchReportResponse> {
    let url_ = this.myAppUrl + "api/CoreData/GetRegOwnerSearchReport";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);
    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processSearchReportResponse(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processSearchReportResponse(<any>response_);
        } catch (e) {
          return <Observable<GetRegOwnerSearchReportResponse>><any>_observableThrow(e);
        }
      } else
        return <Observable<GetRegOwnerSearchReportResponse>><any>_observableThrow(response_);

    }));

  }

  processSearchReportResponse(response: HttpResponseBase): Observable<SearchReportResponseBase> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SearchReportResponseBase.fromJS(resultData200);
        return _observableOf(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<SearchReportResponseBase>(<any>null);

  }

}
